<template>
  <p><component v-for="(item,index) of f.computedcontentobj" v-bind:key="index" :is="item.zujianname" :allindex="allindex" :duanindex="duanindex" :zuizhongindex="item.zuizhongindex" :singleanswerlist="singleanswerlist" :kaoshenganswerlistsingle="kaoshenganswerlistsingle" :fontsize="fontsize">{{item.text}}</component></p>
</template>

<script>
import global from '../components/global'

import singletext from '../components/singletext'

import inputcomp from '../components/inputcomp'

export default {
  components: { singletext, inputcomp },

  props: ['duanindex', 'allindex', 'content', 'singleanswerlist', 'kaoshenganswerlistsingle', 'tusrc', 'fontsize'],

  data () {
    return {
      allobjlist: global.allobjlist,
      list: global.list,
      answerlist: global.answerlist,
      yonghuming: global.yonghuming
    }
  },
  watch: {
    fontsize: function () {
      // alert(global.fontsize)
      this.$forceUpdate()
    }
  },
  computed: {
    f () { // this.content || ''防止空使用tiankongcomps出错
      const computedcontent = (this.content || '').split('&')
      const computedcontentobj = []
      const l = computedcontent.length
      for (let j = 0; j < l - 1; j++) {
        computedcontentobj.push({ zujianname: 'singletext', zuizhongindex: j, text: computedcontent[j] })
        computedcontentobj.push({ zujianname: 'inputcomp', zuizhongindex: j, text: '' })
      }
      computedcontentobj.push({ zujianname: 'singletext', zuizhongindex: l - 1, text: computedcontent[l - 1] })
      return { computedcontentobj }
    }
  }
}
</script>
